import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Table } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import {
  useNextUpReviewContext,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpContext';
import FundingItemRow
  from './Components/FundingItemRow';

const useStyles = buildUseStyles('FundingTable', (() => ({
  root: {},
})));

const FundingTable = ({ collection, readonly }) => {
  const { handleAccountFundingItemUpdate } = useNextUpReviewContext();
  const classes = useStyles();

  if (collection.resources().length() === 0) {
    return null;
  }

  return (
    <Box
      className={classes.root}
    >
      <Table.Table>
        <Table.HeadColumnHeaderSet>
          <Table.HeadColumnHeaderCell value="Create on Activation" />
          <Table.HeadColumnHeaderCell value="Action" />
          <Table.HeadColumnHeaderCell value="Start" />
          <Table.HeadColumnHeaderCell value="Until" />
          <Table.HeadColumnHeaderCell value="Amount" />
        </Table.HeadColumnHeaderSet>
        {collection.resources().list().map((instruction) => (
          <FundingItemRow key={instruction.id()} onChange={handleAccountFundingItemUpdate} resource={instruction} readonly={readonly} />
        ))}
      </Table.Table>
    </Box>
  );
};

FundingTable.defaultProps = {
  readonly: false,
};

FundingTable.propTypes = {
  collection: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
};


export default FundingTable;
